export const ORIGINALSRC_ATTTIBUTE_NAME = 'originalsrc';
export const SHASH_ATTTIBUTE_NAME = 'shash';
export const DATA_AUTH_ATTTIBUTE_NAME = 'data-auth';
export const RESERVED_PARAM = '&reserved=0';
export const VERIFIED_SAFE_LINK = 'Verified';
